export interface IRsvpAdditionalQuestionsCommon {
  inputType: string;
}

export interface IRsvpPlacesCommon {
  link: string;
}

export interface IRsvpCommon {
  clientId: string;
  version: string;
  herName: string;
  hisName: string;
  headerSeparator: string;
  hour: string;
  isClock: boolean;
  mainColor: string;
  buttonColor: string;
  backgroundColor: string;
  places: Array<IRsvpPlacesCommon>;
  additionalQuestions: Array<IRsvpAdditionalQuestionsCommon>;
  headerTextFont: string;
  textFont: string;
  formVersion: string;
  dueToTime: number;
  invitationPurposeTextBold: boolean;

  getValue<T>(key: string): T;
}

export class RsvpCommonClass implements IRsvpCommon {
  clientId: string;
  version: string;
  herName: string;
  hisName: string;
  headerSeparator: string;
  hour: string;
  isClock: boolean;
  mainColor: string;
  buttonColor: string;
  backgroundColor: string;
  places: Array<IRsvpPlacesCommon>;
  additionalQuestions: Array<IRsvpAdditionalQuestionsCommon>;
  headerTextFont: string;
  textFont: string;
  formVersion: string;
  dueToTime: number;
  invitationPurposeTextBold: boolean;

  constructor(rsvp?: Partial<IRsvpCommon>) {
    this.clientId = rsvp?.clientId ?? '';
    this.version = rsvp?.version ?? '';
    this.herName = rsvp?.herName ?? '';
    this.hisName = rsvp?.hisName ?? '';
    this.headerSeparator = rsvp?.headerSeparator ?? '';
    this.hour = rsvp?.hour ?? '';
    this.isClock = rsvp?.isClock ?? false;
    this.mainColor = rsvp?.mainColor ?? '';
    this.buttonColor = rsvp?.buttonColor ?? '';
    this.backgroundColor = rsvp?.backgroundColor ?? '';
    this.places = rsvp?.places ?? [];
    this.additionalQuestions = rsvp?.additionalQuestions ?? [];
    this.headerTextFont = rsvp?.headerTextFont ?? '';
    this.textFont = rsvp?.textFont ?? '';
    this.formVersion = rsvp?.formVersion ?? 'v1';
    this.dueToTime = rsvp?.dueToTime ?? Date.now();
    this.invitationPurposeTextBold = rsvp?.invitationPurposeTextBold ?? false;
  }

  getValue<T>(key: string): T {
    return this[key] as T;
  }
}
